// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAjFH8S0TNOWHC9ymNUehlHhYA99bd6IHA",
  authDomain: "lytesnap-dev.firebaseapp.com",
  projectId: "lytesnap-dev",
  storageBucket: "lytesnap-dev.appspot.com",
  messagingSenderId: "825735513975",
  appId: "1:825735513975:web:56f35a6237a0145deac372",
  measurementId: "G-PM5WHNS0X5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const authWithoutApp = getAuth();
